module.exports = __webpack_public_path__ + "static/media/honey_rush.playngo.eb5b6a01.jpeg";